export const MIN_PASSWORD_LENGTH = 8;

export const ACADLY_HERE_URL =
  'https://www.acadly.com/here?utm_source=acadlysignup1&utm_medium=postverifyrequest1&utm_campaign=acadlyhere';
export const ACADLY_HERE_LOGO_URL = 'https://s3.amazonaws.com/static.acad.ly/img/here-monogram-small.png';
